import { render, staticRenderFns } from "./GlobalNavi.vue?vue&type=template&id=b95e4e6c&"
import script from "./GlobalNavi.vue?vue&type=script&lang=js&"
export * from "./GlobalNavi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports